<template>
  <div class="blog-grid">
    <div class="container">
      <div class="row">
        <div class="col-md-7">
          <div
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="busy"
            infinite-scroll-distance="10"
          >
            <div class="articles" v-if="loading">
              <ArticleSecondSkeleton v-for="(article, i) in 3" :key="i" />
            </div>
            <div class="articles" v-else>
              <ArticleSecond
                :article="article"
                v-for="(article, i) in blogsToShow"
                :key="i"
                :bookMarks="bookMarks"
                @bookMarkBlog="bookMarkBlog"
              />
            </div>
            <ArticleSecondSkeleton v-if="loadingNew" />
          </div>
        </div>
        <div class="col-md-5">
          <div class="related-content">
            <h2 class="heading">DISCOVER MORE OF WHAT MATTERS TO YOU</h2>
            <div class="tags" v-if="loading">
              <b-skeleton type="button" class="skeleton-tag"></b-skeleton>
              <b-skeleton type="button" class="skeleton-tag"></b-skeleton>
              <b-skeleton type="button" class="skeleton-tag"></b-skeleton>
              <b-skeleton type="button" class="skeleton-tag"></b-skeleton>
              <b-skeleton type="button" class="skeleton-tag"></b-skeleton>
            </div>
            <div class="tags" v-else>
              <div v-for="(tag, i) in tags" class="tag" :key="i">{{ tag }}</div>
            </div>
            <div class="ad-area">
              <InArticleAdsense
                data-ad-client="ca-pub-5528403865076419"
                data-ad-slot="f08c47fec0942fa0"
              >
              </InArticleAdsense>
            </div>

            <template v-if="tools.length > 0 || loading">
              <h2 class="heading top-guide">TOP TOOLS</h2>
              <div class="top-guides" v-if="loading">
                <div v-for="(guide, i) in 3" :key="i">
                  <div class="small-card" v-if="i < 3">
                    <div class="profile-img">
                      <b-skeleton type="avatar"></b-skeleton>
                    </div>
                    <h4 class="name">
                      <b-skeleton
                        type="button"
                        height="15px"
                        width="60px"
                      ></b-skeleton>
                    </h4>
                  </div>
                </div>
              </div>
              <div class="top-guides" v-else>
                <div v-for="(tool, i) in tools" :key="i">
                  <div
                    v-if="i < 4"
                    class="small-card"
                    @click="goToTool(tool.name)"
                  >
                    <div class="profile-img">
                      <img
                        class="avatar"
                        v-if="tool.imgURL"
                        :src="tool.imgURL"
                        :alt="tool.name"
                      />
                      <img
                        class="avatar"
                        v-else
                        src="@/assets/img/blogs/Nutrition.svg"
                        :alt="tool.name"
                      />
                    </div>
                    <h4 class="device-name">{{ tool.name }}</h4>
                  </div>
                </div>
              </div>
            </template>
            <div class="horizontal-line footer-top"></div>

            <div class="footer"
                 :class="{ fixed: footerFixed }"
            >
              <router-link
                  tag="span" to="/policy/terms">
                <a style="box-shadow: none; text-shadow: none;">
                  Terms & Condition
                </a>
              </router-link>
              <router-link tag="span" to="/policy/privacy"
                >
                <a style="box-shadow: none; text-shadow: none;">
                  Privacy Policy
                </a>
              </router-link>
              <router-link
                  v-if="!config.isBeta"
                  tag="span"
                  to="/sessions"
                ><a>Sessions 1:1 Video</a></router-link
              >
              <br />
              <span>
                Copyright HeartBeatFam  © 2023
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import ArticleSecond from "./ArticleSecond";
import ArticleSecondSkeleton from "./ArticleSecondSkeleton";
import Ads from "vue-google-adsense";
import config from "@/assets/_config.json";

Vue.use(require("vue-script2"));
Vue.use(Ads.InArticleAdsense);
var infiniteScroll = require("vue-infinite-scroll");

export default {
  name: "BlogsGrid.vue",
  directives: { infiniteScroll },
  data() {
    return {
      footerFixed: false,
      showSearch: true,
      blogsToShow: [],
      loadingNew: false,
      advertisement: {
        showAd: false
      },
      config
    };
  },
  computed: {
    // tags() {
    //   //If the user is signed in pull from list- if they are not signed in - pull from cookies
    //   return ['finance', 'politics','groups'];
    // }
  },
  props: {
    loading: {
      type: Boolean
    },
    blogs: {
      type: Array
    },
    tools: {
      type: Array
    },
    connections: {
      type: Array
    },
    bookMarks: {
      type: Array
    },
    tags: {
      type: Array
    }
  },
  components: {
    ArticleSecond,
    ArticleSecondSkeleton
  },
  mounted() {
    let that = this;
    let oldScroll;
    window.onscroll = function(e) {
      if (
        document.querySelector(".footer") &&
        document.querySelector(".footer").getBoundingClientRect().top <= 130 &&
        oldScroll < window.scrollY
      ) {
        that.footerFixed = true;
      } else if (
        document.querySelector(".footer") &&
        document.querySelector(".footer-top").getBoundingClientRect().top >= 120
      ) {
        if (oldScroll >= window.scrollY) {
          that.footerFixed = false;
        }
      }
      oldScroll = window.scrollY;
    };
  },
  methods: {
    getInitials(fname, lname) {
      //@TODO- Make this a mixin
      let initials = "";
      if (fname) initials += fname[0];
      if (lname) initials += lname[0];
      return initials;
    },
    goToGuide(name) {
      this.$router.push(`/guide/@${name}`);
    },
    goToTool(name) {
      this.$router.push(`/tool/${name}`);
    },
    goToConnection(name) {
      this.$router.push(`/connection/${name}`);
    },
    pushBlogs() {
      let i = this.blogsToShow.length;
      for (let index = i; index < i + 2; index++) {
        if (this.blogs[index]) {
          this.blogsToShow.push(this.blogs[index]);
        }
      }
    },
    loadMore() {
      if (this.blogs.length > this.blogsToShow.length) {
        this.loadingNew = true;
        setTimeout(() => {
          this.pushBlogs();
          this.loadingNew = false;
        }, 500);
      } else return;
    },
    bookMarkBlog(data) {
      this.$emit("bookMarkBlog", data);
    }
  }
};
</script>

<style lang="scss" scoped>
.blog-grid {
  padding-top: 40px;
  .horizontal-line {
    border-top: 1px solid #ddd;
  }
  .related-content {
    .heading {
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
      line-height: 22px;
      letter-spacing: 0.03em;
      color: #474d52;
      margin-bottom: 24px;
    }
    .tags {
      user-select: none;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      grid-gap: 8px;
      margin-bottom: 24px;
      .tag {
        height: 42px;
        background: #ffffff;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12);
        border-radius: 48px;
        padding: 10px 16px;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: #474d52;
        cursor: pointer;
        &:hover {
          box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);
        }
        &.active {
          background: rgba(85, 126, 251, 0.1);
          color: #557efb;
        }
      }
      .skeleton-tag {
        height: 42px;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12);
        border-radius: 48px;
        padding: 10px 16px;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
      }
    }
    .ad-area {
      margin-bottom: 32px;
      img {
        object-fit: cover;
        height: 185px;
        width: 100%;
      }
    }
    .heading.top-guide {
      margin-bottom: 16px;
    }
    .top-guides {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(85px, 1fr));
      grid-column-gap: 14px;
      grid-row-gap: 16px;
      margin-bottom: 48px;
      .small-card {
        cursor: pointer;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.16);
        border-radius: 8px;
        //width: 108px;
        height: 126px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        transition: all 0.3s ease;
        .rating {
          display: grid;
          grid-template-columns: 11px 11px 11px 11px 11px;
          grid-column-gap: 4px;
        }
        &:hover {
          box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.3);
        }
        .profile-img {
          height: 40px;
          width: 40px;
          position: relative;
          margin-bottom: 9px;
          img {
            height: 100%;
            width: 100%;
            border-radius: 50%;
            object-fit: cover;
          }
          .ico-top {
            position: absolute;
            bottom: 0;
            right: 0;
            transform: translate(25%, 15%);
          }
        }
        .name {
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          line-height: 19px;
          color: #52595e;
          margin-bottom: 4px;
        }
        .device-name {
          font-style: normal;
          font-weight: normal;
          font-size: 13px;
          line-height: 22px;
          color: #474d52;
        }
      }
    }
  }
  .footer {
    padding-top: 24px;
    padding-bottom: 44px;
    &.fixed {
      position: fixed;
      top: 124px;
    }
    span {
      margin-right: 16px;
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 22px;
      color: #8d99a0;
      a {
        margin-bottom: 11px;
        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: #8d99a0;
      }
    }
  }
}

@media (max-width: 768px) {
  .cols_ {
    flex-direction: column-reverse !important;
  }
  .footer {
    display: none;
  }
}
</style>
